import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    commentRoot: {
      position: "relative",
      borderBottom: "1px solid #eee"
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 500,
      height: 22,
      color: primary.main,
      marginBottom: 6
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 12,
      color: primary.dark,
      marginBottom: 5
    },
    commentContent: {
      fontSize: 12,
      color: "#333",
      lineHeight: "17px",
      wordBreak: "break-word"
    },
    commenterInfo: {
      display: "flex",
      alignItems: "center"
    },
    info: {
      display: "flex",
      textTransform: "capitalize"
    },
    additionalSigns: {
      display: "initial"
    },
    icon: {
      width: 13,
      marginRight: 8
    },
    uppercase: {
      textTransform: "uppercase"
    },
    commentActions: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "flex-end",
      textAlign: "right"
    },
    commentButton: {
      display: "flex",
      alignItems: "center",
      height: 24,
      width: 24,
      minWidth: 24,
      paddingTop: 4,
      paddingBottom: 4,
      marginLeft: 10,
      borderRadius: 2,
      borderColor: theme.palette.primary.light,
      paddingLeft: 12,
      paddingRight: 12,
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
        padding: 0,
        "& .MuiButton-label": {
          width: 24
        }
      }
    },
    commentButtonIcon: {
      fontSize: 14,
      color: theme.palette.primary.dark
    },
    editMode: {
      padding: "24px 0px 32px"
    },
    warningComment: {
      display: "flex",
      alignItems: "center",
      margin: "10px 0"
    },
    warningIconContainer: {
      display: "flex",
      padding: 3,
      marginRight: 6,
      backgroundColor: "#ff7e00",
      borderRadius: 4
    },
    warningIconColored: {
      fontSize: 10,
      color: theme.palette.common.white
    },
    warningMessage: {
      fontWeight: "bold",
      fontSize: 14
    }
  };
});
